import React, { useState, useEffect } from "react";
import AsyncSelect from "react-select/async";
import api from "../../services/apiService";
import Modal from "../../components/modal";
import GridServerSide from "../../components/grid-server-side";
import BotaoPadrao from "../../components/botao-padrao";
import BotaoDeletar from "../../components/botao-deletar";
import { MdAddBox } from "react-icons/md";
import styles from "./styles.module.css";

const PALETA_PADRAO = ["#ff0000", "#007bff", "#28a745", "#ffc107", "#6f42c1"];

const SeletorCandidatos = ({
  siglaEstado,
  candidatosSelecionados,
  setCandidatosSelecionados,
  maxCandidatos = 20,
  exibirSelecaoCor = false,
}) => {
  const [erro, setErro] = useState(null);
  const [modalAberto, setModalAberto] = useState(false);
  const arrayCargosExecutivo = ["11", "3", "1"];

  const [municipioSelecionado, setMunicipioSelecionado] = useState({
    label: "Todos",
    value: null,
  });
  const [municipios, setMunicipios] = useState([]);
  const [anosEleicoes, setAnosEleicoes] = useState([]);
  const [cargos, setCargos] = useState([]);
  const [cargo, setCargo] = useState("");
  const [anoMiniForm, setAnoMiniForm] = useState("");
  const [turno, setTurno] = useState("");
  const [numeroCandidato, setNumeroCandidato] = useState("");

  useEffect(() => {
    setMunicipioSelecionado({ label: "Todos", value: null });
    setMunicipios([]);
    setCargo("");
    setAnoMiniForm("");
    setTurno("");
    setNumeroCandidato("");
  }, [siglaEstado]);

  useEffect(() => {
    const fetchAnosEleicoes = async () => {
      const response = await api.get("/selects/listar-anos-eleicoes");
      setAnosEleicoes(response.anosEleicoes);
    };

    const fetchCargos = async () => {
      const response = await api.get("/selects/listar-cargos");
      setCargos(response.cargos);
    };

    fetchAnosEleicoes();
    fetchCargos();
  }, []);

  useEffect(() => {
    if (!siglaEstado) {
      return;
    }

    const carregarMunicipios = async () => {
      try {
        const response = await api.get("/selects/listar-municipios-com-resultados", {
          params: { sigla_estado: siglaEstado },
        });

        const lista = (response.municipios || []).map((m) => ({
          label: m.nome_municipio,
          value: m.id_municipio,
        }));

        setMunicipios([{ label: "Todos", value: null }, ...lista]);
      } catch (error) {
        console.error("Erro ao carregar municípios:", error.message);
        setErro("Erro ao carregar municípios.");
      }
    };

    carregarMunicipios();
  }, [siglaEstado]);

  const validarMiniForm = () => {
    if (!cargo) return "Selecione um cargo.";
    if (!anoMiniForm) return "Selecione um ano.";
    if (arrayCargosExecutivo.includes(cargo) && !turno) {
      return "Selecione um turno.";
    }
    return null;
  };

  const abrirModal = () => {
    setErro("");
    const erroValidacao = validarMiniForm();
    if (erroValidacao) {
      setErro(erroValidacao);
      return;
    }
    setModalAberto(true);
  };

  const buscarMunicipios = async (nomeMunicipio) => {
    const texto = (nomeMunicipio || "").toLowerCase().trim();

    if (!texto) {
      return municipios.slice(0, 100);
    }

    return municipios.filter((item) =>
      item.label.toLowerCase().includes(texto)
    );
  };

  const buscarCandidatosModal = async (
    pagina = 1,
    porPagina = 10,
    nomeCandidato = ""
  ) => {
    const municipio = municipioSelecionado.value;
    try {
      const response = await api.get("/selects/buscar-candidatos", {
        params: {
          page: pagina,
          per_page: porPagina,
          sigla_estado: siglaEstado,
          id_municipio: municipio,
          codigo_cargo: cargo,
          ano_eleicao: anoMiniForm,
          turno_eleicao: turno,
          numero_candidato: numeroCandidato,
          nome_candidato: nomeCandidato,
        },
      });

      const rowsFiltradas = response.data.filter(
        (row) =>
          !candidatosSelecionados.some(
            (c) => String(c.id_candidato) === String(row.id_candidato)
          )
      );

      return { rows: rowsFiltradas, total: response.total };
    } catch (error) {
      console.error("Erro ao buscar candidatos:", error.message);
      setErro("Erro ao buscar candidato.");
      return { rows: [], total: 0 };
    }
  };

  const adicionarCandidatoLista = (candidatoEscolhido) => {
    if (!candidatoEscolhido) return;
    if (candidatosSelecionados.length >= maxCandidatos) return;
    if (
      candidatosSelecionados.some(
        (c) => c.id_candidato === candidatoEscolhido.id_candidato
      )
    ) {
      return;
    }

    const corPadrao =
      PALETA_PADRAO[candidatosSelecionados.length % PALETA_PADRAO.length];

    setCandidatosSelecionados([
      ...candidatosSelecionados,
      { ...candidatoEscolhido, cor: corPadrao },
    ]);
  };

  const removerCandidato = (candidato) => {
    setCandidatosSelecionados(
      candidatosSelecionados.filter(
        (item) => item.id_candidato !== candidato.id_candidato
      )
    );
  };

  const alterarCor = (id_candidato, novaCor) => {
    setCandidatosSelecionados((prev) =>
      prev.map((c) =>
        c.id_candidato === id_candidato ? { ...c, cor: novaCor } : c
      )
    );
  };

  const defColunasGrid = [
    { headerName: "Nome", field: "nome_candidato", flex: 2 },
    { headerName: "Votos", field: "total_votos_candidato", flex: 1 },
    { headerName: "Situação", field: "situacao_candidato", flex: 2 },
    { headerName: "Partido", field: "partido_candidato", flex: 1 },
    { headerName: "Cargo", field: "cargo_candidato", flex: 1 },
    {
      headerName: "Adicionar",
      field: "acoes",
      cellRenderer: (params) => (
        <button
          type="button"
          onClick={() => adicionarCandidatoLista(params.data)}
          className={styles.botaoAdicionarCandidato}
        >
          <MdAddBox className={styles.iconeAdicionarCandidato} />
        </button>
      ),
      flex: 1,
    },
  ];

  return (
    <div className={styles.candidatosContainer}>
      <label>Candidatos (máx. {maxCandidatos}):</label>
      {erro && <div className={styles.erro}>{erro}</div>}

      <div className={styles.filtrosCandidatos}>
        <div className={styles.formGroup}>
          <label>Município do candidato:</label>
          <AsyncSelect
            cacheOptions
            defaultOptions={municipios}
            loadOptions={buscarMunicipios}
            value={municipioSelecionado}
            onChange={(selected) => setMunicipioSelecionado(selected)}
            placeholder="Digite o nome do município"
            className={styles.AsyncSelect}
            classNamePrefix="formSelect"
            isDisabled={!siglaEstado}
          />
        </div>

        <div className={styles.formGroup}>
          <label>Cargo:</label>
          <select
            value={cargo}
            onChange={(e) => setCargo(e.target.value)}
            disabled={!siglaEstado}
          >
            <option value="">Selecione o cargo</option>
            {cargos.map((c) => (
              <option key={c.codigo_cargo} value={c.codigo_cargo}>
                {c.nome_cargo}
              </option>
            ))}
          </select>
        </div>

        <div className={styles.formGroup}>
          <label>Ano:</label>
          <select
            value={anoMiniForm}
            onChange={(e) => setAnoMiniForm(e.target.value)}
            disabled={!siglaEstado}
          >
            <option value="">Selecione o ano</option>
            {anosEleicoes.map((a) => (
              <option key={a.ano_eleicao} value={a.ano_eleicao}>
                {a.ano_eleicao}
              </option>
            ))}
          </select>
        </div>

        {arrayCargosExecutivo.includes(cargo) && (
          <div className={styles.formGroup}>
            <label>Turno:</label>
            <select
              value={turno}
              onChange={(e) => setTurno(e.target.value)}
              disabled={!siglaEstado}
            >
              <option value="">Selecione o turno</option>
              <option value="1">1º turno</option>
              <option value="2">2º turno</option>
            </select>
          </div>
        )}

        <div className={styles.formGroup}>
          <label>Número:</label>
          <input
            type="text"
            value={numeroCandidato}
            onChange={(e) => setNumeroCandidato(e.target.value)}
            placeholder="Número do candidato"
            disabled={!siglaEstado}
          />
        </div>

        <div className={styles.formGroup}>
          <label>&nbsp;</label>
          <BotaoPadrao
            onClick={abrirModal}
            label="Buscar Candidatos"
            disabled={!siglaEstado}
          />
        </div>
      </div>

      {candidatosSelecionados.length > 0 && (
        <ul className={styles.listaCandidatos}>
          {candidatosSelecionados.map((candidato) => (
            <li key={candidato.id_candidato} className={styles.itemCandidato}>
              <div className={styles.infoCandidato}>
                {`${candidato.nome_candidato} - ${candidato.cargo_candidato} (${candidato.ano_eleicao_candidato})`}
              </div>

              {exibirSelecaoCor && (
                <div className={styles.corPicker}>
                  <label>Cor:</label>
                  <input
                    type="color"
                    value={candidato.cor || "#000000"}
                    onChange={(e) =>
                      alterarCor(candidato.id_candidato, e.target.value)
                    }
                  />
                </div>
              )}

              <BotaoDeletar onClick={() => removerCandidato(candidato)} />
            </li>
          ))}
        </ul>
      )}

      <Modal
        titulo="Candidatos"
        isOpen={modalAberto}
        onClose={() => setModalAberto(false)}
      >
        {modalAberto && (
          <GridServerSide
            fetchData={buscarCandidatosModal}
            columnDefs={defColunasGrid}
            paginationPageSize={10}
          />
        )}
      </Modal>
    </div>
  );
};

export default SeletorCandidatos;